import * as TYPES from './types';

export const secureMessageLegalHeaderLoaded = (legalMessage) => ({
  type: TYPES.SECURE_MESSAGE_LEGAL_HEADER_LOADED,
  legalMessage,
});

export const careProviderSelected = (careProviderId) => ({
  type: TYPES.CARE_PROVIDER_SELECTED,
  recipient: careProviderId,
});

export const messageThreadsLoaded = (threads, language, timeZone, timeZoneOffset) => ({
  type: TYPES.SECURE_MESSAGES_THREADS_LOADED,
  threads,
  language,
  timeZone,
  timeZoneOffset,
});

export const threadMessagesLoaded = (messages, language, timeZone, timeZoneOffset) => ({
  type: TYPES.SECURE_MESSAGES_THREAD_LOAD_SUCCESS,
  messages,
  language,
  timeZone,
  timeZoneOffset,
});

export const messageFilterToggled = (filter) => ({
  type: TYPES.SECURE_MESSAGES_TOGGLE_FILTER_PANEL,
  filter,
});

export const showSecureMessageReplyItem = (isVisible) => ({
  type: TYPES.SHOW_SECURE_MESSAGE_REPLY_ITEM,
  isVisible,
});

export const secureMessageThreadSelected = (threadId) => ({
  type: TYPES.SECURE_MESSAGE_THREAD_THREAD_SELECTED,
  threadId,
});

export const secureMessageArchivedThreadSelected = (threadId) => ({
  type: TYPES.SECURE_MESSAGE_ARCHIVE_THREAD_SELECTED,
  threadId,
});

export const secureMessageThreadClear = () => ({
  type: TYPES.SECURE_MESSAGE_THREAD_CLEAR,
  messages: [],
});

export const secureMessageListViewCompact = (isListView) => ({
  type: TYPES.SHOW_SECURE_MESSAGE_LIST_VIEW,
  isListView,
});

export const secureMessageUnreadCountLoaded = (unreadCount) => ({
  type: TYPES.SECURE_MESSAGES_UNREAD_COUNT_LOADED,
  unreadCount,
});

